'use client';

import { c as _c } from "react/compiler-runtime";
import ROUTES from '@lib/constants/routes';
import { visibleScrollSelector } from '@lib/store/slices/ComponentsSlice';
import { animated, useSpring } from '@react-spring/web';
import { useSelector } from 'react-redux';
const AnimationWrapper = t0 => {
  const $ = _c(12);
  const {
    children,
    path
  } = t0;
  const visibleScroll = useSelector(visibleScrollSelector);
  const isMainPage = path === ROUTES.root;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      duration: 500
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = visibleScroll ? 0 : 1;
  let t3;
  if ($[1] !== t2) {
    t3 = {
      config: t1,
      opacity: t2,
      delay: 0
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const opacityStyle = useSpring(t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      duration: 10
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = !visibleScroll ? 1 : 0;
  let t6;
  if ($[4] !== t5) {
    t6 = {
      config: t4,
      opacity: t5,
      delay: 0
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const opacityStyleRevers = useSpring(t6);
  let t7;
  if ($[6] !== children || $[7] !== isMainPage || $[8] !== opacityStyle || $[9] !== opacityStyleRevers || $[10] !== visibleScroll) {
    t7 = isMainPage ? <animated.div style={visibleScroll ? opacityStyleRevers : opacityStyle}>{children}</animated.div> : <>{children}</>;
    $[6] = children;
    $[7] = isMainPage;
    $[8] = opacityStyle;
    $[9] = opacityStyleRevers;
    $[10] = visibleScroll;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default AnimationWrapper;